export const licenseIsDefault = {
  type: "boolean"
};
